module.exports = __webpack_public_path__ + "img/img23.79731c24.svg";